import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion as ExpansionPanel,
  AccordionSummary as ExpansionPanelSummary,
  AccordionDetails as ExpansionPanelDetails,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  IconButton,
  Select,
  TextField
} from '@mui/material';
import { Title, Text, ButtonOptions } from 'shared/components';
import {
  Help as HelpIcon,
  ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';
import useStyles from './styles';
import { getHelpText } from '../../utils/cube/constants';

const CardSettingsDonations = ({
  OPTIONS,
  form,
  segmentOptions,
  compareOptions,
  handleChangeForm
}) => {
  const classes = useStyles();
  return (
    <>
      <TextField
        label="Display name (optional)"
        value={form.customName}
        onChange={e => handleChangeForm('customName', e.target.value)}
        variant="outlined"
        size="small"
        fullWidth
        inputProps={{ style: { fontSize: 14 } }}
      />
      <ExpansionPanel className={classes.expansionPanel}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Segment</Title>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <IconButton aria-label="help">
                  <HelpIcon />
                </IconButton>
              }
              subheader={
                <Text className={classes.subHeaderSubCard}>
                  How do you want to group the data? (Calculations will be made
                  separately for each group displayed side-by-side)
                </Text>
              }
            />
            <CardContent className={classes.cardContent}>
              <Grid container spacing={1}>
                <Grid item xs={12} className={classes.gutterBottomCardRow}>
                  <ButtonOptions
                    titleMarging={20}
                    options={segmentOptions}
                    onChange={value => handleChangeForm('segment', value)}
                    value={form.segment}
                    optionsTextHelper={getHelpText}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel className={classes.expansionPanel}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Filters</Title>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Card className={classes.rootSubCard}>
                <CardHeader
                  action={
                    <IconButton aria-label="help">
                      <HelpIcon />
                    </IconButton>
                  }
                  subheader={
                    <Text className={classes.subHeaderSubCard}>
                      What data do you want to include?
                    </Text>
                  }
                />
                <CardContent className={classes.cardContent}>
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    style={{ textAlign: 'left' }}
                  >
                    <Grid item xs={6} className={[classes.gutterBottomCardRow, classes.flexAuto]}>
                      <ButtonOptions
                        titleMarging={20}
                        optionsObject={OPTIONS.YEAR}
                        options={OPTIONS.FILTER}
                        onChange={value => handleChangeForm('filter', value)}
                        float
                        value={form.filter}
                        optionsTextHelper={getHelpText}
                      />
                    </Grid>
                    <Grid item xs={6} className={classes.gutterBottomCardRow}>
                      <ButtonOptions
                        titleMarging={20}
                        options={OPTIONS.STATUS}
                        onChange={value => handleChangeForm('status', value)}
                        float
                        value={form.status}
                        optionsTextHelper={getHelpText}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card className={classes.rootSubCard}>
                <CardHeader
                  action={
                    <IconButton aria-label="help">
                      <HelpIcon />
                    </IconButton>
                  }
                  title={
                    <Title className={classes.titleSubCard}>
                      Donation Type
                    </Title>
                  }
                />
                <CardContent className={classes.cardContent}>
                  <FormControl className={classes.selectContainer}>
                    <Select
                      native
                      value={form.donationType}
                      onChange={e =>
                        handleChangeForm('donationType', e.target.value)
                      }
                      className={classes.selectText}
                    >
                      {OPTIONS.DONATIONS_TYPE.map(type => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel className={classes.expansionPanel}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Comparison</Title>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <IconButton aria-label="help">
                  <HelpIcon />
                </IconButton>
              }
              subheader={
                <Text className={classes.subHeaderSubCard}>
                  What do you want to compare your results with?
                </Text>
              }
            />
            <CardContent className={classes.cardContent}>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
                style={{ textAlign: 'left' }}
              >
                <Grid item xs={12} className={classes.gutterBottomCardRow}>
                  <ButtonOptions
                    titleMarging={20}
                    options={compareOptions}
                    optionsObject={OPTIONS.COMPARISONYEAR}
                    onChange={value => handleChangeForm('compare', value)}
                    float
                    value={form.compare}
                    optionsTextHelper={getHelpText}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </>
  );
};

CardSettingsDonations.propTypes = {
  OPTIONS: PropTypes.object,
  form: PropTypes.object,
  segmentOptions: PropTypes.array,
  compareOptions: PropTypes.array,
  handleChangeForm: PropTypes.func,
};

export default CardSettingsDonations;
